import firebase from 'firebase/app'
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCgiX3_6JuJEQvzq8AS_jJ6wSGu3_3aZsw",
  authDomain: "jhl-agentti.firebaseapp.com",
  databaseURL: "https://jhl-agentti.firebaseio.com",
  projectId: "jhl-agentti",
  storageBucket: "jhl-agentti.appspot.com",
  messagingSenderId: "181058614293",
  appId: "1:181058614293:web:f04c2a1d61beba7ce38a1c"
};

const firebaseApp = firebase.initializeApp(firebaseConfig)

export default firebaseApp.firestore();
